import type { HeaderImage } from '@xing-com/crate-common-graphql-types';

export const imageSizes = '(max-width: 1112px) 100vw, 984px';

export const buildSrcSet = (images: Array<HeaderImage>): string =>
  images.map(({ url, reference }) => `${url} ${reference}w`).join(', ');
